import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Row = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content:  center;
`

export const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin: ${({ isloan }) => (isloan ? '0px 16px' : '0px')};

  @media (max-width: 820px) {
    flex-direction: column;
    align-items: normal;
  }
`
export const SubText = styled.div`
  color: ${colors.strongGray};
  width: 20%;
  font-size: 16px;

  @media (max-width: 820px) {
    font-size: 15px;
    width: 70%;
  }
  @media (max-width: 340px ){
    font-size: 13px;
  }

`
export const Pages = styled.div`
  display: flex;
  width: 60%;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  @media (max-width: 820px) {
    margin-top: 10px;
    width: 100%;
  }
`

export const Page = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${({ actualpage }) => (actualpage ? colors.primary : '')};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: ${({ actualpage }) => (actualpage ? colors.titleStrongWhite : colors.strongGray)};
  margin: 0 5px;
  cursor: ${({ actualpage }) => (actualpage ? '' : 'pointer')};
  &:hover {
    background-color: ${({ actualpage }) => (actualpage ? colors.primary : colors.softGray)};
  }

  @media (max-width: 450px) {
    width: 26px;
    height: 26px;
  }
  @media (max-width: 410px) {
    width: 22px;
    height: 22px;
  }
  @media (max-width: 360px) {
    width: 18px;
    height: 18px;
    font-size: 13px;
  }
`

export const PageSize = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;
`

export const SelectLabel = styled.div`
  color: ${colors.strongGray};
  @media(max-width: 820px) {
    display: none;
  }
`
